/* eslint-disable no-console */
/* eslint-disable no-undef */
import { HueDisabled, Wrap } from './styles';

import styleMock from 'views/MapView/services/symbologiesStyles.json';

import Divider from '@material-ui/core/Divider';
import { hsvaToHex } from '@uiw/color-convert'
import Hue from '@uiw/react-color-hue';
/**
 * useEffect é um hook que permite executar efeitos colaterais em
 * seus componentes, por exemplo: buscar dados, atualizar diretamente
 * o DOM e cronômetros, ele aceita dois argumentos o segundo é opcional
 */
import { useEffect, useState } from 'react';

/**
 * SymbologySwitch
 * 
 * @param {string} geometryType
 * @param {boolean} selectedSymbology
 * @param {function} onSelected
 * @param {boolean} disabled
 * @param {boolean} autoSelect
 * @param {*} props Ressto
 * 
 * @returns 
 */
export const SymbologySwitch = ({
  geometryType,
  selectedSymbology,
  onSelect,
  disabled,
  autoSelect = true,
  ...props
}) => {

  const [hsva, setHsva] = useState({ h: 217, s: 100, v: 100, a: 1 })  
  const [color, setColor] = useState('#D4E4FF')

  useEffect(() => {
    setColor(hsvaToHex({ h: hsva.h, s: hsva.s, v: hsva.v, a: hsva.a }))    
  }, [hsva]);
  
  useEffect(() => {    
    if(!disabled){
      let geometryStyleMock 
      if (geometryType === 'Point') {
        geometryStyleMock = structuredClone(styleMock.find((s) => s.for === 'Point' && s.default));
      } else if (geometryType === 'Line' || geometryType === 'LineString') {
        geometryStyleMock = structuredClone(styleMock.find((s) => s.for === 'Line' && s.default));
      } else if (geometryType === 'Polygon') {
        geometryStyleMock = structuredClone(styleMock.find((s) => s.for === 'Polygon' && s.default));
      }
  
      geometryStyleMock.color = color
      geometryStyleMock.fillColor = color
      onSelect(geometryStyleMock)
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [disabled, color]);
  

  return (
    <Wrap style={props.style}>
      <h3>Selecione cor da simbologia</h3>
      <Divider />
      {!disabled && (
        <Hue       
          className="hue"   
          hue={hsva.h}
          onChange={(newHue) => {
            setHsva({ ...hsva, ...newHue });         
          }}
        /> 
      )}
      {disabled && (
        <HueDisabled  className="hue-disabled"/>
      )}      
    </Wrap>
  );
};

SymbologySwitch.properties = {
  ignore: true,
};

export default SymbologySwitch;